import View from '@shared/components/layout-default/layout-default-router-view';

export const db = [
  {
    path: 'db',
    component: View,
    children: [
      {
        path: '',
        name: 'db.index',
        redirect: {
          name: 'db.database.index'
        }
      },

      {
        path: 'databases',
        component: View,
        children: [
          {
            path: '',
            name: 'db.database.index',
            component: () =>
              import(
                /* webpackChunkName: 'db' */
                '@db/pages/db-list-page'
              ),
            meta: {
              title: {
                code: 'db.breadcrumb.database.index'
              }
            }
          },

          {
            path: ':id([\\d]*)',
            name: 'db.database.edit',
            component: () =>
              import(
                /* webpackChunkName: 'db' */
                '@db/pages/db-show-page'
              ),
            meta: {
              loadable: true
            }
          },
          {
            path: ':database_id([\\d]*)/recipients',
            name: 'db.database.recipient.create',
            component: () =>
              import(
                /* webpackChunkName: 'db' */
                '@db/pages/recipients-create-edit-page'
              ),
            meta: {
              title: {
                code: 'db.breadcrumb.database.recipient.create',
                loadable: true
              }
            }
          },
          {
            path: ':database_id([\\d]*)/recipients/:recipient_id([\\d]*)',
            name: 'db.database.recipient.edit',
            component: () =>
              import(
                /* webpackChunkName: 'db' */
                '@db/pages/recipients-create-edit-page'
              ),
            meta: {
              title: {
                code: 'db.breadcrumb.database.recipient.edit',
                loadable: true
              }
            }
          },

          {
            path: ':database_id([\\d]*)/import/:file_id([\\d]*)',
            props: true,
            name: 'db.database.import',
            component: () => import(/* webpackChunkName: 'db' */ '@db/pages/db-recipients-import'),
            meta: {
              title: {
                code: 'db.breadcrumb.database.recipient.import',
                loadable: true
              }
            }
          }
        ]
      },

      {
        path: 'groups',
        name: 'db.group.index',
        component: () => import(/* webpackChunkName: 'db' */ '@db/pages/db-group-page'),
        meta: {
          title: {
            code: 'db.breadcrumb.group.index'
          }
        }
      }
    ]
  }
];
